import { useContext, useEffect, useMemo, useState } from 'react'
import { FaEye, FaSearch } from "react-icons/fa";
import { DataProvider } from '../store/ContextProvider';
import { fetchNewCandidateProfile } from '../services/fetchCandidate'
import ListCandidates from './ListCandidate';

export default function ViewNewcomer() {
    const { BeURL, showAlert } = useContext(DataProvider);

    // list state
    const [users, setNewUsers] = useState([]);
    const [pagination, setPagination] = useState({ page: 1, perPage: 10, totalPages: 1, total: 0 });
    const [isProfile, setProfile] = useState(true)

    // Toggle set
    const handleToggle = () => {
        setProfile(prev => !prev);
    };


    // filters (source of truth for fetch)
    const [filters, setFilters] = useState({
        page: 1,
        perPage: 10,
        search: "",
        // sortField: "fullName",
    });

    // UI state
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const [viewUser, setViewUser] = useState(null);


    // debounced search application
    useEffect(() => {
        const t = setTimeout(() => {
            setFilters((f) => ({
                ...f,
                page: 1,
                search: searchTerm.trim(),
            }));
        }, 400);
        return () => clearTimeout(t);
    }, [searchTerm]);

    // fetch users with abort safety
    useEffect(() => {
        const ctrl = new AbortController();

        const fetchUsers = async () => {
            try {
                setLoading(true);
                const qs = new URLSearchParams(filters).toString();

                await fetchNewCandidateProfile(qs, ctrl, setPagination, setNewUsers, BeURL, showAlert, setLoading, filters)
            } catch (e) {
                if (e.name !== "AbortError") showAlert("Unable to load users.");
            } finally {
                setLoading(false);
            }
        };
        fetchUsers();
        return () => ctrl.abort();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [BeURL, filters]);

    const changePerPage = (n) => setFilters((f) => ({ ...f, perPage: Number(n), page: 1 }));
    const goPage = (delta) =>
        setFilters((f) => ({
            ...f,
            page: Math.max(1, Math.min(f.page + delta, pagination.totalPages || 1)),
        }));

    // search button enablement
    const canSearch = useMemo(() => {
        const s = searchTerm.trim();
        return s.length === 0 || s.length >= 3;
    }, [searchTerm]);

    // view user
    const openView = async (id) => {

        setViewUser(users.find(u => u._id === id))

        // try {
        //   const r = await fetch(`${BeURL}/admin/users/${id}`, { credentials: "include" });
        //   const d = await r.json();
        //   d?.success ? setViewUser(d.user) : showAlert(d?.message || "Cannot fetch user.");
        // } catch {
        //   showAlert("Cannot fetch user.");
        // }
    };


    // Table Columns
    const columns = [

        { key: "fullName", label: "Full Name", },
        isProfile ? { key: "score", label: "Score", sortKey: "score" } : { key: "contact", label: "Contact", },
        { key: "createdAt", label: "Created At", },

    ];


    return (
        <div className="p-6 space-y-4 min-h-[100vh] relative">
            <div className='flex flex-wrap gap-6 justify-center my-3'>
                <h1 className={`text-2xl font-semibold ${isProfile ? "text-primary-500" : "text-secondary-500"}`}>{isProfile ? 'New Candidate Profile' : 'New Users'} </h1>
                {/* <button className='rounded-full px-4 py-1 text-md bg-secondary-500 hover:bg-secondary-600 text-white' onClick={() => window.location.href= '/signUpEmployer'}>Create Employer</button> */}
            </div>

            {/* Toggle set */}
            <div className="flex items-center gap-3 justify-center pt-3">
                {/* Candidate Profile text */}
                <span
                    className={`${isProfile ? "text-primary-500 font-bold" : "text-gray-400"
                        }`}
                >
                    New Candidate Profile
                </span>

                {/* Toggle button */}
                <button
                    onClick={handleToggle}
                    className={`w-12 h-6 flex items-center rounded-full p-1 duration-300 ${isProfile
                        ? "bg-primary-500 justify-start"
                        : "bg-secondary-500 justify-end"
                        }`}
                >
                    <div className="w-5 h-5 bg-white rounded-full shadow-md"></div>
                </button>
                {/* New Users text */}
                <span
                    className={`${!isProfile ? "text-secondary-500 font-bold" : "text-gray-400"
                        }`}
                >
                    New Users
                </span>
            </div>


{!isProfile ? 
                <>
                    {/* Filters */}
                    <div className="flex flex-wrap gap-4">
                        <div className="flex flex-1 max-w-md">
                            <input
                                type="search"
                                placeholder="Search users (min 3 chars)… or contact"
                                className="flex-1 border rounded-l px-3 py-2 focus:outline-none"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <button
                                disabled={!canSearch}
                                onClick={() =>
                                    setFilters((f) => ({ ...f, search: searchTerm.trim(), page: 1 }))
                                }
                                className={`px-4 ${isProfile ? 'bg-primary-500 hover:bg-primary-600' : 'bg-secondary-500 hover:bg-secondary-600'}  disabled:opacity-60 text-white rounded-r flex items-center`}
                                title="Apply search"
                            >
                                <FaSearch className="mr-2" /> Search
                            </button>
                        </div>

                    </div>

                    {/* Table */}
                    <div className="overflow-x-auto bg-white rounded shadow">
                        <table className="w-full table-auto">
                            <thead className={`${isProfile ? "text-primary-500 bg-blue-100" : "text-secondary-500 bg-purple-100"}`}>
                                <tr>
                                    <th className="p-3 text-left font-semibold">S.No</th>

                                    {columns.map(({ key, label }) => (
                                        <th
                                            key={key}
                                            className="p-3 text-left cursor-pointer select-none font-semibold"

                                        >
                                            {label}

                                        </th>
                                    ))}
                                    <th className="p-3 text-center font-semibold">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={columns.length + 1} className="p-6 text-center">
                                            Loading…
                                        </td>
                                    </tr>
                                ) : users.length === 0 ? (
                                    <tr>
                                        <td colSpan={columns.length + 1} className="p-6 text-center">
                                            No users found.
                                        </td>
                                    </tr>
                                ) : (
                                    users.map((u, i) => (
                                        <tr
                                            key={u._id}
                                            className={`border-b hover:bg-gray-50 ${i % 2 === 0 ? "" : "bg-slate-50"}`}
                                        >
                                            <td className="p-3">{i + 1}</td>

                                            <td className="p-3">{u.fullName}</td>
                                            <td className="p-3">{u.contact}</td>
                                            <td className="p-3">{u.createdAt ? new Date(u?.createdAt).toLocaleString("en-GB") : '-'}</td>

                                            <td className="p-3 text-center space-x-2">
                                                <button
                                                    onClick={() => openView(u._id)}
                                                    className="text-slate-600 hover:text-slate-800"
                                                    title="View"
                                                >
                                                    <FaEye />
                                                </button>

                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}


                    <div className="mx-auto my-4 flex justify-around items-center">
                        <div className="flex items-center gap-2">
                            <label htmlFor="recordsPerPage" className="text-sm">Records per page:</label>
                            <select
                                className="border rounded px-3 py-2"
                                value={filters.perPage}
                                onChange={(e) => changePerPage(e.target.value)}
                            >
                                {[10, 20, 25, 50, 75, 100].map((n) => (
                                    <option key={n} value={n}>
                                        {n}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <button
                                disabled={filters.page === 1}
                                onClick={() => goPage(-1)}
                                className="px-3 py-1 bg-white border rounded disabled:opacity-50"
                            >
                                Prev
                            </button>
                            <span>
                                Page {pagination.page} of {pagination.totalPages}
                            </span>
                            <button
                                disabled={pagination.page === pagination.totalPages}
                                onClick={() => goPage(+1)}
                                className="px-3 py-1 bg-white border rounded disabled:opacity-50"
                            >
                                Next
                            </button>
                        </div>
                        <div className="text-sm">Total New Comers: {pagination.totalCount}</div>
                    </div>
                </> :
                <ListCandidates columns={columns} FaEye={FaEye} FaSearch={FaSearch}/>
}
            

            {/* View Modal */}
            {
                viewUser && (
                    <div className="fixed inset-0 z-50 bg-black/30 flex items-center justify-center ">
                        <div className="bg-white p-6 rounded-lg max-w-sm w-full space-y-2">
                            <h3 className="text-xl font-semibold text-primary-400">User Details</h3>
                            {["_id", "id", "fullName", "email", "contact", "role"].map((k) => (
                                <div key={k}>
                                    <span className="font-medium">
                                        {k === "_id" ? "ID" : k === 'id' ? 'User Id' : k.at(0).toUpperCase() + k.slice(1).replace(/([A-Z])/g, " $1")}:
                                    </span>{" "}
                                    <span>{k === "_id" ? viewUser?._id : viewUser?.[k]}</span>
                                </div>
                            ))}
                            <button
                                onClick={() => setViewUser(null)}
                                className="mt-4 px-4 py-2 bg-primary-400 text-white rounded"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                )
            }





        </div >
    );
}
